import { render, staticRenderFns } from "./AssessmentResult.vue?vue&type=template&id=3fc6bafa&scoped=true&"
import script from "./AssessmentResult.vue?vue&type=script&lang=ts&"
export * from "./AssessmentResult.vue?vue&type=script&lang=ts&"
import style0 from "./AssessmentResult.vue?vue&type=style&index=0&id=3fc6bafa&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc6bafa",
  null
  
)

export default component.exports